<template>
  <v-footer>
    <v-row class="pr-8 pl-8">
      <v-col cols="12" xl="6" md="6" sm="6" xs="12" v-if="!$vuetify.breakpoint.xs">
        <v-img 
          alt="UNL" 
          class="mx-auto my-auto" 
          contain 
          height="42px" 
          position="center left" 
          :src="require('@/assets/icons/unl_identidad.svg')">
        </v-img>
      </v-col>

      <v-col cols="12" xl="6" md="6" sm="6" xs="12" class="lista1">
        
        <v-row class="d-flex justify-end mt-0">
          <v-col class="d-flex justify-end">
            <a class="ma-1 my-auto" href="https://www.facebook.com/VinculacionUNL/" target="_blank">
              <v-img 
                alt="UNL" 
                contain
                max-width="14px" 
                max-height="14px"
                :src="require('@/assets/icons/facebook.svg')">
              </v-img>
            </a>
              
            <a class="ma-1 my-auto" href="https://twitter.com/vinculacionunl/" target="_blank">
              <v-img 
                alt="UNL" 
                contain
                max-width="14px" 
                max-height="14px" 
                :src="require('@/assets/icons/twitter.svg')">
              </v-img>
            </a>
              
            <a class="ma-1 my-auto" href="https://www.instagram.com/vinculacionunl/" target="_blank">
              <v-img 
                alt="UNL" 
                max-width="14px" 
                max-height="14px" 
                :src="require('@/assets/icons/instagram.svg')">
              </v-img>
            </a>
              
            <a class="ma-1 my-auto" href="https://www.linkedin.com/in/vinculaciontecnologicaunl/" target="_blank">
              <v-img 
                alt="UNL" 
                contain
                max-width="14px" 
                max-height="14px" 
                :src="require('@/assets/icons/linkedin.svg')">
              </v-img>
            </a>

            <a class="ma-1 my-auto" href="https://www.youtube.com/@VinculacionUNL" target="_blank">
              <v-img 
                alt="UNL" 
                contain
                max-width="14px" 
                max-height="14px" 
                :src="require('@/assets/icons/youtube.svg')">
              </v-img>
            </a>
            
            <p class="white--text text-right my-auto ml-2" style="font-size: 11px;">
              VINCULACION<b>UNL</b> · emprendedores@unl.edu.ar · www.unl.edu.ar/emprendedores
            </p>
          </v-col>

        </v-row>

      </v-col>
    </v-row>
  </v-footer>
</template>
<script>

export default {
  data: () => ({
  })
};
</script>
<style scoped>
.v-footer{
  background-color: black;
  height: 80px;
}

.lista1 {
  display: inline-block;
}

.lista1 v-img {
  display: inline-block;
}

</style>